var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{name: 'win_streak_info', params: {winStreakId: _vm.winStreakId}}}},[_vm._v("\n  "+_vm._s(_vm.lable)+" "+_vm._s(_vm.winStreakId)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }